// shared functions
window.DropdownFunctionUtils = {
  initDropdown(selectBoxId, selectId, optionsWrapperId, searchBoxId, optionsListId, hiddenId) {
    const selectBox = document.getElementById(selectBoxId);
    const selectValue = document.getElementById(selectId);
    const optionsWrapper = document.getElementById(optionsWrapperId);
    const searchBox = document.getElementById(searchBoxId);
    const optionsList = document.getElementById(optionsListId);
    const hiddenInput = document.getElementById(hiddenId);
    let currentFocusIndex = -1;

    selectBox.addEventListener("click", () => {
      console.log('click')
      const isActive = window.getComputedStyle(optionsWrapper).display === "block";
      optionsWrapper.style.display = isActive ? "none" : "block";
      selectValue.textContent = ""; // ← 改成 textContent
      filterOptions("");

      if (!isActive && searchBox) {
        setTimeout(() => {
          searchBox.focus();
        }, 0);
      }
    });

    if(searchBox){
      // Filter list items on input
      searchBox.addEventListener("input", (e) => {
        filterOptions(e.target.value.toLowerCase());
      });
    }

    // Handle click on list item
    optionsList.addEventListener("click", (e) => {
      if (e.target.tagName === "LI") {
        const value = e.target.getAttribute("data-value");
        selectValue.textContent = e.target.textContent;
        hiddenInput.value = value;
        optionsWrapper.style.display = "none";
      }
    });

    document.addEventListener("mousedown", (e) => {
      if (
        !selectBox.contains(e.target) &&
        !optionsWrapper.contains(e.target)
      ) {
        optionsWrapper.style.display = "none";
      }
    });

    // Keyboard support for arrow navigation and Enter
    searchBox.addEventListener("keydown", (e) => {
      const visibleOptions = Array.from(optionsList.querySelectorAll("li"))
        .filter(opt => opt.style.display !== "none");
      if (visibleOptions.length === 0) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        currentFocusIndex = (currentFocusIndex + 1) % visibleOptions.length;
        console.log('currentFocusIndex', currentFocusIndex)
        updateHighlight();
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        currentFocusIndex = (currentFocusIndex - 1 + visibleOptions.length) % visibleOptions.length;
        updateHighlight();
      }

      if (e.key === "Enter") {
        e.preventDefault();
        if (visibleOptions[currentFocusIndex]) {
          selectOption(visibleOptions[currentFocusIndex]);
        }
      }
    });

    // Filters options by keyword
    function filterOptions(searchTerm) {
      const options = optionsList.querySelectorAll("li");
      const visibleOptions = [];

      options.forEach((opt) => {
        const text = opt.textContent.toLowerCase();
        const isVisible = text.includes(searchTerm);
        opt.style.display = isVisible ? "block" : "none";
        opt.classList.remove("highlight");

        if (isVisible) {
          visibleOptions.push(opt);
        }
      });

      // high light first one filter option
      if (visibleOptions.length > 0) {
        currentFocusIndex = 0;
        visibleOptions[0].classList.add("highlight");
      } else {
        currentFocusIndex = -1;
      }
    }

    // Highlights current focus item
    function updateHighlight() {
      const options = Array.from(optionsList.querySelectorAll("li"))
        .filter(opt => opt.style.display !== "none");

      options.forEach((opt, i) => {
        opt.classList.toggle("highlight", i === currentFocusIndex);
      });

    }

    // Sets selected value and hides dropdown
    function selectOption(optionEl) {
      const value = optionEl.getAttribute("data-value") || optionEl.textContent;
      selectValue.textContent = optionEl.textContent;
      hiddenInput.value = value;
      optionsWrapper.style.display = "none";
      searchBox.value = "";
      currentFocusIndex = -1;
    }
  }
}